<template>
  <div class="wrapper" :style="{ 'max-width': maxWidth }">
    <input v-model="data" class="px-2 input-style" :placeholder="placeholder" @keyup.enter="change" />
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    maxWidth: {
      type: String,
      default: '150px',
    },
  },
  data() {
    return {
      data: '',
    }
  },
  mounted() {
    this.data = this.value
  },
  methods: {
    change() {
      this.$emit('change', this.data)
    },
  },
  watch: {
    data() {
      this.$emit('input', this.data)
    },
    value() {
      this.data = this.value
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  border: 1px solid #00000066;
  border-radius: 4px;
  background: white;
  height: 28px;
  overflow: hidden;

  &:hover {
    border: 1px solid black;
  }
}
.input-style {
  height: 100%;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
  width: 100%;

  &::placeholder {
    color: #00000066;
  }
}
</style>
